import axios from 'axios';
export default
{
    getFullReportList: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/reports/GetFullReport';
        const response=await axios.get(url,{crossDomain:true,headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    getDisposalReport: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/reports/GetDisposalReport';
        const response=await axios.get(url,{crossDomain:true,headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    GetRadiationShutterCheckList: async function()
    {
        const token=localStorage.getItem('accessToken');
        const url='/reports/GetRadiationShutterCheckList';
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    },
    getLeakTestReport: async function(){
        const token=localStorage.getItem('accessToken');
        const url='/reports/GetLeakTestReport';
        const response=await axios.get(url, {crossDomain:true, headers:{ 'Authorization':'Bearer '+token}});
        return response;
    }

}